import axios from "axios";

const baseUrl = `${import.meta.env.VITE_API_URL}`;

export const crcService = {
    getCartorios: (cpf) => {
      return axios.get(`${baseUrl}/crc/notary-user/${cpf}`, null, null);
    },
    getModulo: (payload) => {
      return axios.post(`${baseUrl}/crc/usuario/modulo`, payload, null);
    },
    envioEmailCertidao: (payload) => {
      return axios.post(`${baseUrl}/public/crc/email/certidao`, payload, null);
    },
};